export default __webpack_public_path__ + "static/media/tetra-grand.cc050cfc.webp";